export const areValuesEmpty = (object) =>{
  if(!object) return true
  return Object.keys(object).every(
    (key) => !object[key] || object[key].length === 0 || object[key] === null
  )
}
